import { safeDefineElement } from '@/scripts/core/global'
import { MediaGallery } from '@/scripts/product/media-gallery'
import { ProductStickyCta } from '@/scripts/product/product-sticky-cta'
import { CustomAfterpay } from '@/scripts/product/custom-afterpay'

safeDefineElement(MediaGallery)
safeDefineElement(ProductStickyCta)
safeDefineElement(CustomAfterpay)
